import { render, staticRenderFns } from "./event-search-config.vue?vue&type=template&id=11537dea"
import script from "./event-search-config.vue?vue&type=script&lang=ts"
export * from "./event-search-config.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports